<template>
  <div class="about">
    <div class="about-top">
      <img src="../../assets/img/about-bg.png" class="about-bg" />
      <div class="about-wrap">
        <div class="about-text">
          <h3>平台介绍</h3>
          <p>
            艺科美课（北京）科技有限公司是一家关于传统工艺美术行业的新型互联网教育公司，旗下主营业务为“工艺美课”远程教育平台，自2014年国家制定工艺美术创新远程教育平台发展规划后正式启动。
          </p>
          <p>
            平台内聚合了清华美院及其他专业学院师资资源中国工艺美术大师及省级大师、国家级及省级非遗传承人等大量专家教授和顶尖行业大师；以研究型教育、普通高等教育、职业技术教育继续教育不同层次和不同类别的课程为依托，致力做全国最大的传统工艺一站式教育平台，为我国工艺美术教育事业以及工艺美术产业的发展贡献力量。
          </p>
          <p>
            平台针对不同用户下设全品类、全方位、全群体的多元化教学课程，拥有以漆画、漆器、陶瓷、纤维、金属、玻璃、染织、雕刻唐卡、其他这十大类为主的线上课程，从工艺史论、工艺技法及鉴赏、工艺设计及案例教学三大板块进行系统的培训，开创工美行业前所未有的“线上学习+校园指导+基地实践”的立体教育模式。让学员从根本上得到提升，实现从技能提升到岗位提升的能力闭环
          </p>
          <p>
            平台线下针对院校开设了名师入校和传习基地进行实践教育，名师入校是将平台所拥有的海量高校教授以及工美大师和非遗传承人资源，引进院校，为学生定制专题课堂。传习基地是与大师合作建立全国性线下实践网络，根据学生学习状况匹配合适的传习基地进行周期性的学习。
          </p>
          <p>
            平台作为中国工艺美术学会唯一数字教育合作平台，将为传统工艺美术行业从业者提供定向教育及整体培训，从理论建设、技艺提升、思维创新等方向提升从业者的专业素养；以工艺美术体验活动为载体，推行线下工艺基地建设；以提兴趣、拓眼界、做普及为方向，为青少年开展社会美育教育，增强工艺美术行业的社会影响力。
          </p>
        </div>
      </div>
    </div>
    <div class="time-line">
      <div class="box" v-for="(item, index) in timeLineList" :key="index">
        <div v-if="item.flag" class="info-wrap">
          <em>{{ item.year }}</em>
          <span>{{ item.title }}</span>
        </div>
        <div v-if="!item.flag" class="info-wrap">
          <span>{{ item.title }}</span>
          <em>{{ item.year }}</em>
        </div>
        <div class="box-display">
          <img :src="item.image" />
          <ul class="content">
            <li>{{ item.description }}</li>
          </ul>
        </div>
      </div>
    </div>
    <img :src="bannerObj.image" class="about-img" />
    <div class="collect-data">
      <h3>留言</h3>
      <form action="">
        <div class="person-info">
          <p><label for="name">姓名</label></p>
          <p>
            <input id="name" type="text" autocomplete="off" v-model="params.name" />
          </p>
          <p><label for="phone">电话</label></p>
          <p>
            <input id="phone" type="text" autocomplete="off" v-model="params.phone" />
          </p>
          <p><label for="email">邮箱</label></p>
          <p>
            <input id="email" type="text" autocomplete="off" v-model="params.email" />
          </p>
        </div>
        <div class="msg-con">
          <p><label for="con">内容</label></p>
          <p>
            <input
              id="con"
              type="text"
              placeholder="请输入留言标题"
              autocomplete="off"
              v-model="params.title"
            />
          </p>
          <p>
            <textarea
              id="textarea"
              type="text"
              autocomplete="off"
              v-model="params.content"
            ></textarea>
          </p>
          <p><button @click="handleSend">确定</button></p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { artMilestone, artFeedBack } from "@/api/About";
import { artBannerList } from "@/api/ExpertThinkTank";
export default {
  name: "About",
  data() {
    return {
      bannerObj: {},
      timeLineList: [
        // {
        //   id: 0,
        //   year: 2014,
        //   description: "制定国家工艺美术创新远程教育平台发展规划",
        //   flag: true,
        // },
        // {
        //   id: 1,
        //   year: 2016,
        //   description: "搭建平台框架",
        //   flag: true,
        // },
        // {
        //   id: 2,
        //   year: 2017,
        //   description: "完成远程网络学习初步建设成果",
        //   flag: false,
        // },
        // {
        //   id: 3,
        //   year: 2019,
        //   description: "网络平台1.0正式上线并运行",
        //   flag: false,
        // },
        // {
        //   id: 4,
        //   year: 2021,
        //   description: "再次调整传统工艺网络课程体系",
        //   flag: false,
        // },
        // {
        //   id: 3,
        //   year: 2022,
        //   description: "正式更名为工艺美课",
        //   flag: true,
        // },
      ],
      params: {
        name: "",
        phone: "",
        email: "",
        title: "",
        content: "",
      },
    };
  },
  mounted() {
    this.artMilestoneFunc();
    this.artBannerListFunc();
  },
  methods: {
    handleSend() {
      artFeedBack(this.params)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    artBannerListFunc() {
      artBannerList({
        area: 5,
      })
        .then((res) => {
          this.bannerObj = res.data[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    artMilestoneFunc() {
      artMilestone()
        .then((res) => {
          console.log(res);
          let data = res.data;
          data[0].flag = data[1].flag = true;
          data[2].flag = false;
          this.timeLineList = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.about {
  .about-top {
    position: relative;
    overflow: hidden;
    .about-bg {
      width: 1920px;
      height: 847px;
      transform: rotateY(180deg);
    }
    .about-wrap {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(85, 85, 85, 0.5);
      .about-text {
        width: 1240px;
        margin: 0 auto;
        color: #fff;
        h3 {
          margin: 88px 0 56px;
          font-size: 26px;
          color: #fff;
        }
        p {
          margin-bottom: 29px;
          width: 852px;
          line-height: 29px;
          text-indent: 2em;
          text-shadow: 1px 1px 0px rgb(0 0 0 / 65%);
          font: lighter 15px/29px "PingFangSC-Ultralight", "PingFang SC Ultralight",
            "PingFang SC", sans-serif;
        }
      }
    }
  }
  .time-line {
    width: 100%;
    height: 500px;
    background: url("../../assets/img/time-line.png") no-repeat;
    background-size: 100% 500px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    cursor: default;
    .box {
      flex-grow: 1;
      height: 200px;
      position: relative;
      &:hover .box-display {
        display: block !important;
      }
      &::before {
        content: "";
        width: 100%;
        height: 4px;
        background-color: #847f7f;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%);
      }
      &::after {
        content: "";
        width: 17px;
        height: 17px;
        border: 4px solid #fff;
        background-color: #2d3f51;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -8px;
        margin-left: -8px;
      }
      .info-wrap {
        width: 180px;
        height: 116px;
        text-align: center;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -58px;
        margin-left: -90px;
        em {
          display: block;
          font-size: 38px;
          color: #2d3f51;
          margin-bottom: 17px;
          font-style: italic;
        }
        span {
          display: block;
          min-height: 44px;
          line-height: 22px;
          font-size: 16px;
          color: #4b4949;
          margin-bottom: 19px;
        }
      }
      .box-display {
        display: none;
        overflow: hidden;
        width: 295px;
        height: 340px;
        position: absolute;
        top: 50%;
        z-index: 2;
        margin-top: -170px;
        border-radius: 10px;
        box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
        img {
          width: 100%;
          height: 186px;
        }
        .content {
          padding: 20px 20px 0;
          height: 154px;
          background-color: #fff;
          li {
            padding-left: 12px;
            line-height: 17px;
            margin-bottom: 3px;
            font-size: 12px;
            color: #2d3f51;
            position: relative;
            &::before {
              content: "";
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background-color: #da514e;
              position: absolute;
              left: 0;
              top: 5px;
            }
          }
        }
      }
    }
  }
  .about-img {
    width: 100%;
    height: 415px;
  }
  .collect-data {
    h3 {
      padding: 81px 0 65px;
      margin: 0;
      font-size: 20px;
      color: #333;
      text-align: center;
    }
    form {
      margin: 0 auto;
      width: 1240px;
      display: flex;
      justify-content: space-between;
      p {
        margin: 0;
      }
      label {
        font-size: 15px;
        height: 41px;
        line-height: 41px;
        color: #7f7f7f;
      }
      input,
      textarea {
        box-sizing: border-box;
        border: 1px solid #d7d7d7;
        margin-bottom: 31px;
        text-indent: 20px;
      }
      .person-info {
        width: 360px;
      }
      .msg-con {
        width: 814px;
        button {
          margin: 0 0 50px 130px;
          width: 163px;
          height: 45px;
          line-height: 43px;
          border: 1px solid #d7d7d7;
          color: #333;
          text-align: center;
          background: transparent;
          &:hover {
            background-color: #2d3f51;
            color: #fff;
          }
        }
      }
    }
    #name {
      width: 131px;
      height: 38px;
      padding: 0;
    }
    #phone,
    #email {
      width: 360px;
      height: 38px;
    }
    #con {
      width: 814px;
      height: 38px;
      margin-bottom: 0;
      border-bottom: none;
    }
    #textarea {
      width: 814px;
      height: 220px;
      margin-bottom: 74px;
      resize: none;
    }

    input::-webkit-input-placeholder {
      /* WebKit browsers */
      color: #d7d7d7;
    }
    input:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #d7d7d7;
    }
    input::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #d7d7d7;
    }
    input:-ms-input-placeholder {
      /* Internet Explorer 10+ */
      color: #d7d7d7;
    }
  }
}
</style>
